<template>
  <div class="section modes-section">
    <div class="container">
      <p class="is-size-3 is-size-4-touch subtitle has-text-centered">
        Students can practice their speaking in <b>Reading mode</b> and improve
        their listening and spelling in <b>Dictation mode</b>
      </p>
      <br />
      <div class="columns is-vcentered">
        <div class="column">
          <figure class="pic">
            <img
              :data-src="require('@/assets/bubble-reading.webp')"
              class="lazyload"
              alt="Reading mode"
            />
          </figure>
        </div>
        <div class="column">
          <h4 class="title is-size-3 is-size-4-touch">
            Reading mode
          </h4>
          <p class="subtitle is-size-4 is-size-6-touch">
            Listen. Read aloud. Compare.
          </p>
          <div class="content is-size-5 is-size-7-touch">
            <ul>
              <li>Listen how a native speaker reads the paragraph</li>
              <li>Record yourself reading the same text</li>
              <li>Compare with the original</li>
              <li>Share the recording with your tutor</li>
              <li>Get feedback</li>
            </ul>
          </div>
          <div class="pt-2">
            <b-button
              tag="router-link"
              to="/library"
              type="is-info"
              size="is-medium"
            >
              <span class="has-text-weight-bold">Explore the library</span>
            </b-button>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column">
          <figure class="pic">
            <img
              :data-src="require('@/assets/bubble-dictation.webp')"
              class="lazyload"
              alt="Dictation mode"
            />
          </figure>
        </div>
        <div class="column">
          <h4 class="title is-size-3 is-size-4-touch">
            Dictation mode
          </h4>
          <p class="subtitle is-size-4 is-size-6-touch">
            Listening + Spelling = Fun
          </p>
          <div class="content is-size-5 is-size-7-touch">
            <ul>
              <li>Adjust the <i>obscurity level</i></li>
              <li>Listen to the audio</li>
              <li>Fill in the hidden words</li>
            </ul>
          </div>
          <div class="pt-2">
            <b-button
              tag="router-link"
              to="/library"
              type="is-info"
              size="is-medium"
            >
              <span class="has-text-weight-bold">Explore the library</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.gif {
  border: 5px solid;
}
</style>
